import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { debounce } from 'lodash';
import { Search } from '@material-ui/icons';
import NestedSelect from 'common/NestedSelect';
import ThemedTextField from 'common/ThemedTextField';
const searchIcon = React.createElement(Search, null);
const defaultFilterOptions = {
    status: [
        {
            text: i18n.t('orders:status.DRAFT'),
            value: 'DRAFT',
            selected: false,
        },
        {
            text: i18n.t('orders:status.APPROVED'),
            value: 'APPROVED',
            selected: false,
        },
        {
            text: i18n.t('orders:status.CANCELLED'),
            value: 'CANCELLED',
            selected: false,
        },
        {
            text: i18n.t('orders:status.DONE'),
            value: 'DONE',
            selected: false,
        },
    ],
};
const OrderFilters = ({ onSearch, statuses, onChangeStatuses, }) => {
    const { t } = useTranslation('common');
    const [filterOptions, setFilterOptions] = useState(defaultFilterOptions);
    const [searchInput, setSearchInput] = useState('');
    const [searchStatus, setSearchStatus] = useState('');
    const updateStatus = useCallback((newStatuses) => {
        setFilterOptions({
            status: newStatuses,
        });
        setSearchStatus(newStatuses
            .filter((option) => option.selected)
            .map((option) => option.text)
            .join(', '));
    }, [setFilterOptions, setSearchStatus]);
    useEffect(() => {
        updateStatus(defaultFilterOptions.status.map((option) => (Object.assign(Object.assign({}, option), { selected: statuses.includes(option.value) }))));
    }, [statuses, updateStatus]);
    const debounceSearch = useMemo(() => debounce(onSearch, 500), [onSearch]);
    const handleSearch = useCallback((e) => {
        setSearchInput(e.target.value);
        debounceSearch(e.target.value);
    }, [setSearchInput, debounceSearch]);
    const handleClearSearch = useCallback(() => {
        setSearchInput('');
        debounceSearch('');
    }, [setSearchInput, debounceSearch]);
    const handleChangeStatus = useCallback(({ target: { value } }) => {
        const newStatuses = filterOptions.status.map((option) => (Object.assign(Object.assign({}, option), { selected: option.value === value ? !option.selected : option.selected })));
        updateStatus(newStatuses);
        onChangeStatuses(newStatuses.filter((option) => option.selected).map((option) => option.value));
    }, [filterOptions, updateStatus, onChangeStatuses]);
    return (React.createElement("div", { className: "module-filters" },
        React.createElement(ThemedTextField, { icon: searchIcon, label: t('type_search_text'), name: "searchPhrase", value: searchInput, onChange: handleSearch, onClickClear: handleClearSearch, className: "filters__search" }),
        React.createElement(NestedSelect, { variant: "Dropdown", value: searchStatus, name: "searchStatus", onChange: handleChangeStatus, options: filterOptions, label: t('orders:status'), className: "filters__status" })));
};
export default memo(OrderFilters);
